import { APP_ROUTES } from 'swag-client-common/constants/app-routes';
import { checkoutStarted } from 'swag-client-common/redux/cart/cart.actions';
import { showPopup } from 'swag-client-common/redux/popup-manager/popup-manager.actions';
import { CART_BOXES_SPECIAL_PRODUCTS_WARNING, CHECKOUT_OUT_OF_STOCK_ADJUSTMENT_POPUP, ITEMS_VALIDATION_CONFLICTS_POPUP, SAMPLE_AND_REGULAR_PRODUCTS_POPUP, SUPER_SPEED_WARNING_POPUP, CHECKOUT_PRINT_LOCATION_WARNINGS_POPUP } from 'swag-client-common/constants';
import { validateSuperSpeedForCheckout } from 'swag-client-common/redux/settings/settings-other.actions';
import { redirectWithSavingScroll } from 'swag-client-common/utils/tricks';
export const checkoutBlockDispatcher = dispatch => ({
  showSuperSpeedWarningPopup: () => {
    dispatch(showPopup({
      popup: SUPER_SPEED_WARNING_POPUP
    }));
  },
  showItemsConflictPopup: () => {
    dispatch(showPopup({
      popup: ITEMS_VALIDATION_CONFLICTS_POPUP
    }));
  },
  showCartBoxesSpecialProductsWarningPopup: () => {
    dispatch(showPopup({
      popup: CART_BOXES_SPECIAL_PRODUCTS_WARNING
    }));
  },
  showCheckoutOutOfStockAdjustmentPopup: () => {
    dispatch(showPopup({
      popup: CHECKOUT_OUT_OF_STOCK_ADJUSTMENT_POPUP
    }));
  },
  showCheckoutLEQtyAdjustmentPopup: () => {
    dispatch(showPopup({
      popup: CHECKOUT_OUT_OF_STOCK_ADJUSTMENT_POPUP
    }));
  },
  onCheckoutStart: () => {
    redirectWithSavingScroll(APP_ROUTES.DELIVERY)();
    dispatch(checkoutStarted());
  },
  showSampleAndRegularProductsPopup: () => {
    dispatch(showPopup({
      popup: SAMPLE_AND_REGULAR_PRODUCTS_POPUP
    }));
  },
  showCheckoutPrintLocationWarningsPopup: () => {
    dispatch(showPopup({
      popup: CHECKOUT_PRINT_LOCATION_WARNINGS_POPUP
    }));
  },
  validateSuperSpeedItems: () => {
    dispatch(validateSuperSpeedForCheckout());
  }
});